import React, { useState, useEffect } from 'react';
import propTypes, { bool } from 'prop-types';
import classNames from 'classnames';
import { TextField } from '@material-ui/core';
import InputButton from '../InputButton';
import {
  confirmPasswordValidation,
} from '../../../utils';
import copies from './copies';
import styles from './ConfirmPasswordInput.module.css';

const ConfirmPasswordInput = ({
  id,
  name,
  value,
  onChange,
  label,
  className,
  isSubmitting,
  password,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    if (isSubmitting) {
      setShowPassword(false);
    }
  }, [isSubmitting]);
  const validateConfirmationPassword = value.length >= 1
      && !confirmPasswordValidation(password, value);
  return (
    <div className={classNames(styles.container, className)}>
      <TextField
        id={id}
        name={name}
        label={label}
        className={styles.input}
        variant="filled"
        type={showPassword ? 'text' : 'password'}
        error={validateConfirmationPassword}
        helperText={validateConfirmationPassword ? copies.confirmPasswordError : ''}
        InputProps={{
          endAdornment: (
            <InputButton
              setVisibility={setShowPassword}
              visibility={showPassword}
            />),
          inputProps: { autoComplete: 'off' },
        }}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};
ConfirmPasswordInput.propTypes = {
  id: propTypes.string.isRequired,
  name: propTypes.string.isRequired,
  value: propTypes.string.isRequired,
  className: propTypes.string,
  label: propTypes.string,
  onChange: propTypes.func,
  isSubmitting: bool,
  password: propTypes.string.isRequired,
};

ConfirmPasswordInput.defaultProps = {
  label: '',
  className: '',
  onChange: () => {},
  isSubmitting: false,
};

export default ConfirmPasswordInput;
